import { PermissoesPasta } from '@/core/enums/permissoes-pasta'
import { downloadByButton } from '@/core/components/uploader-utils'
import {
  GenerateDownloadLinkMutationMutation,
  GenerateDownloadLinkMutationMutationVariables,
  ItemBiblioteca
} from '@/core/types/graphql'

type DownloadLinkInput = {
  variables: GenerateDownloadLinkMutationMutationVariables
}

type DownloadLinkGenerator = (
  input: DownloadLinkInput
) => Promise<GenerateDownloadLinkMutationMutation>

type DownloadItem = {
  id: ItemBiblioteca['id']
}

type PermissionItem =
  | {
      permissoesAcessoUsuarioLogado?: ItemBiblioteca['permissoesAcessoUsuarioLogado']
    }
  | null
  | undefined

export function download(
  generateDownloadLink: DownloadLinkGenerator,
  { id }: DownloadItem
) {
  generateDownloadLink({
    variables: { id }
  }).then(({ gerarLinkDownloadByItemBiblioteca: link }) => {
    downloadByButton(link)
  })
}

export function hasWritePermission(item: PermissionItem) {
  const { permissoesAcessoUsuarioLogado = [] } = item || {}
  const ids = permissoesAcessoUsuarioLogado.map(obj => obj!.id)

  return ids.indexOf(PermissoesPasta.LEITURA_ESCRITA) > -1
}
